//把js对象转换成字符串，并存到session
const sSet=function (key,obj) {
  sessionStorage.setItem(key,JSON.stringify(obj))
};
const sGet=function (key) {
  let r='';
  if (sessionStorage.getItem(key)!=='undefined') {
    r=JSON.parse(sessionStorage.getItem(key))
  }
  return r
};
const lSet=function (key,obj) {
  localStorage.setItem(key,JSON.stringify(obj))
};
const lGet=function (key) {
  return JSON.parse(localStorage.getItem(key))
};
const lRemove=function (key) {
  localStorage.removeItem(key);
};
//install方法
export default function (vx) {
  vx.prototype.$session={sSet,sGet};
  vx.prototype.$local={lSet,lGet,lRemove}
}



// WEBPACK FOOTER //
// ./src/modules/commonMethods/sessionAndLocalStorage.js